import script from "./FeaturesContainer.vue?vue&type=script&lang=ts"
export * from "./FeaturesContainer.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__